import mutations from "./mutations";
import queries from "./queries";
import subscriptions from "./subscriptions";

export default {
  mutations,
  queries,
  subscriptions,
};
